;

function loadingFunction(fn) {
  document.readyState === "loading"
    ? window.addEventListener("DOMContentLoaded", fn)
    : fn();
}

function initCnt() {
  // mtYm
  (function (m, e, t, r, i, k, a) {
    m[i] = m[i] || function () {
      (m[i].a = m[i].a || []).push(arguments)
    };
    m[i].l = 1 * new
    Date();
    k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
  })
  (window, document, "script", "https://mc.yandex.ru/metrika/tag.js",
    "ym");
  ym(22647787, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    ecommerce: "dataLayer"
  });

// gglTman

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'G-ZV5EY5LM45');

  /*!-- Carrot quest START --*/
  !function () {
    function t(t, e) {
      return function () {
        window.carrotquestasync.push(t, arguments)
      }
    }

    if ("undefined" == typeof carrotquest) {
      var e = document.createElement("script");
      e.type = "text/javascript", e.async = !0, e.src = "https://cdn.carrotquest.app/api.min.js", document.getElementsByTagName("head")[0].appendChild(e), window.carrotquest = {}, window.carrotquestasync = [], carrotquest.settings = {};
      for (var n = ["connect", "track", "identify", "auth", "onReady", "addCallback", "removeCallback", "trackMessageInteraction"], a = 0; a < n.length; a++) carrotquest[n[a]] = t(n[a])
    }
  }(), carrotquest.connect("58441-eaa515a65924d939e7fa89070e");
  /*!-- Carrot quest END --*/
  /*!-- Roistat Counter Start --*/
  (function (w, d, s, h, id) {
    w.roistatProjectId = id;
    w.roistatHost = h;
    var p = d.location.protocol == "https:" ? "https://" : "http://";
    var u = /^.*roistat_visit=[^;]+(.*)?$/.test(d.cookie) ? "/dist/module.js" : "/api/site/1.0/" + id + "/init?referrer=" + encodeURIComponent(d.location.href);
    var js = d.createElement(s);
    js.charset = "UTF-8";
    js.async = 1;
    js.src = p + h + u;
    var js2 = d.getElementsByTagName(s)[0];
    js2.parentNode.insertBefore(js, js2);
  })(window, document, 'script', 'cloud.roistat.com', '629d70b21ad8bc960ceff6a3a4a5ef19');
  /*!-- Roistat Counter End --*/

  /* INTEGRATION WITH B24  */
  (function (w, d, u) {
    var s = d.createElement('script');
    s.async = true;
    s.src = u + '?' + (Date.now() / 60000 | 0);
    var h = d.getElementsByTagName('script')[0];
    h.parentNode.insertBefore(s, h);
  })(window, document, 'https://cdn-ru.bitrix24.ru/b27244762/crm/tag/call.tracker.js');
  /* INTEGRATION WITH B24 */
}

// old key GTM-WD35MQ7,
function fkBtnAndLink(btnSelector, linkSelector) {
  const fkBtn = document.querySelector(btnSelector);
  const fkLink = document.querySelector(linkSelector);
  if (!(fkBtn && fkLink)) return;
  fkBtn.addEventListener('click', () => {
    ym(22647787, 'reachGoal', 'data-type-btn|fk-btn');
  });
  fkLink.addEventListener('click', (e) => {
    e.preventDefault();
    ym(22647787, 'reachGoal', 'data-type-link|fk-link')
  });
}

/*!-- Carrot quest BEGIN --*/
function startAnalitics() {

  let offsetStart = () => (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
  if (offsetStart() > 0) {
    initCnt();
  } else {
    if (location.href.indexOf('/personal/cart/') > -1) {
      initCnt();
    } else {
      document.addEventListener('scroll', () => {
        initCnt();
      }, {once: true});
    }
  }
}

//loadingFunction(()=>{
document.addEventListener('readystatechange', (event) => {
  if (event.target.readyState === 'complete') {

    startAnalitics();
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      dataLayer.push(arguments);
    };
    window.gtag('js', new Date());

    window.gtag('config', 'G-ZV5EY5LM45');
    //window.gtag('config', 'G-ZMR34YKXXR');
    fkBtnAndLink('.fk-btn', '.fk-link');
  }
});

//});
